import _classCallCheck from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createClass.js";
/* eslint-disable */

import { deepMix, each, wrapBehavior } from '@antv/util';
import { modifyCSS } from '@antv/dom-util';
var DetailPanel = /*#__PURE__*/function () {
  function DetailPanel(cfgs) {
    _classCallCheck(this, DetailPanel);
    this._cfgs = deepMix(this.getDefaultCfg(), cfgs);
  }
  _createClass(DetailPanel, [{
    key: "getDefaultCfg",
    value: function getDefaultCfg() {
      return {
        container: null
      };
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._cfgs[key];
    }
  }, {
    key: "set",
    value: function set(key, val) {
      this._cfgs[key] = val;
    }
  }, {
    key: "initPlugin",
    value: function initPlugin(graph) {
      var self = this;
      this.set('graph', graph);
      var events = self.getEvents();
      var bindEvents = {};
      each(events, function (v, k) {
        var event = wrapBehavior(self, v);
        bindEvents[k] = event;
        graph.on(k, event);
      });
      this._events = bindEvents;
      this.updatePanel();
    }
  }, {
    key: "updatePanel",
    value: function updatePanel() {
      var graph = this.get('graph');
      var parentNode = this.get('container');
      var selectedItems = graph.get('selectedItems');
      var selectedItem = null;
      var clazz = null;
      if (selectedItems && selectedItems.length > 0) {
        selectedItem = graph.findById(selectedItems[0]);
        clazz = selectedItem.getModel().clazz;
      }
      each(parentNode.children, function (child, i) {
        if (child.hasAttribute('data-clazz')) {
          var clazzName = child.getAttribute('data-clazz');
          if (clazz && clazz === clazzName) {
            modifyCSS(child, {
              display: 'inline'
            });
          } else {
            modifyCSS(child, {
              display: 'none'
            });
          }
        }
      });
    }
  }, {
    key: "getEvents",
    value: function getEvents() {
      return {
        afteritemselected: 'updatePanel'
      };
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.get('canvas').destroy();
      var container = this.get('container');
      container.parentNode.removeChild(container);
    }
  }]);
  return DetailPanel;
}();
export default DetailPanel;